import { render } from "./AccountNotification.vue?vue&type=template&id=6bd7b7ef&scoped=true&lang=pug"
import script from "./AccountNotification.vue?vue&type=script&lang=js"
export * from "./AccountNotification.vue?vue&type=script&lang=js"

import "./AccountNotification.vue?vue&type=style&index=0&id=6bd7b7ef&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd7b7ef"]])

export default __exports__